// src/Login.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { messaging } from "./firebase";
import { getToken } from "firebase/messaging";
import "./style-new.css";

const VAPID_KEY = "BEE86sjp3_dNwDVQQEsIhXgpr-DvCsbPz_xFty3sV4Gxbk--8M8iT9qgA30zEiK3Fu6GGN6rDc4b1CakjlceTis";

async function saveTokenToBackend(fcmToken, authToken) {
  await fetch("/api/users/fcm-token", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`
    },
    body: JSON.stringify({ fcmToken })
  });
  console.log("✅ FCM token saved to backend");
}

async function requestNotificationPermission(authToken) {
  console.log("🔔 requestNotificationPermission called");

  if (!("Notification" in window)) {
    console.warn("Browser does not support notifications.");
    return;
  }

  if (Notification.permission === "denied") {
    console.warn("Notifications blocked by user.");
    return;
  }

  if (Notification.permission === "granted") {
    try {
      const token = await getToken(messaging, { vapidKey: VAPID_KEY });
      console.log("🔥 Device Token:", token);
      await saveTokenToBackend(token, authToken);
    } catch (err) {
      console.error("Error getting FCM token:", err);
    }
    return;
  }

  // Permission is "default" — request it (requires user gesture on iOS)
  const permission = await Notification.requestPermission();
  if (permission === "granted") {
    try {
      const token = await getToken(messaging, { vapidKey: VAPID_KEY });
      console.log("🔥 Device Token:", token);
      await saveTokenToBackend(token, authToken);
    } catch (err) {
      console.error("Error getting FCM token:", err);
    }
  }
}

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const navigate = useNavigate();


  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://teamo.co.za/api/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        const token = data.token;
        localStorage.setItem("authToken", token);

        const payload = JSON.parse(atob(token.split('.')[1]));
        const currentUser = {
          id: payload.id,
          name: payload.name,
          email: payload.email,
          isAdmin: payload.is_admin,
        };
        localStorage.setItem("currentUser", JSON.stringify(currentUser));

        // ✅ Request notification permission right after login (user gesture satisfies iOS requirement)
        await requestNotificationPermission(token);

        navigate("/");
      } else {
        setErrorMessage(
          <>
            Invalid email or password, or{" "}
            <a href="http://teamo.co.za/signup" target="_blank" rel="noopener noreferrer">
              sign up here
            </a>
            .
          </>
        );
      }
    } catch (err) {
      setErrorMessage("An error occurred, please try again.");
    }
  };

  return (
    <div className="form-container">
      <h1>Login</h1>
      <form onSubmit={handleLogin} className="form">
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="input"
        />
         <div style={{ position: "relative" }}>
  <input
    type={showPassword ? "text" : "password"}
    placeholder="Password"
    value={password}
    onChange={(e) => setPassword(e.target.value)}
    required
    className="input"
    style={{ paddingRight: "2.5rem" }}
  />
  <span
    onClick={() => setShowPassword(!showPassword)}
    style={{
      position: "absolute",
      right: "0.75rem",
      top: "50%",
      transform: "translateY(-50%)",
      cursor: "pointer",
      fontSize: "1.1rem",
      userSelect: "none",
      color: "#888"
    }}
  >
    {showPassword ? "🙈" : "👁️"}
  </span>
</div>
        <button type="submit" className="btn btn-primary full-width">
          Login
        </button>
      </form>
      <button
        type="button"
        className="btn btn-grey full-width"
        onClick={() => navigate("/forgot-password")}
      >
        Forgot Password?
      </button>
      {errorMessage && <p className="error-message">{errorMessage}</p>}
    </div>
  );
};

export default Login;
